import { Component, OnInit, HostBinding } from '@angular/core';

import { Observable } from 'rxjs';
import { tap, pluck, filter } from 'rxjs/operators';

import { Provider } from '../../../../redux/models/invoices/segments.report.model';
import { SegmentsService } from '../../../../redux/services/invoices/segments.service';
import { diveTrigger } from '../../../../redux/models/dashboard/animations';

@Component({
  standalone: false,
  selector: 'app-invoices-providers',
  templateUrl: './providers-table.component.html',
  animations: [diveTrigger]
})
export class ProvidersComponent implements OnInit {
  @HostBinding() class = 'segments-providers-table';
  reportState$: Observable<any>;
  hidden = true;
  selectedRecord: number;
  doughnutRecord: number;
  doughnutDiveState = 'in';
  solidData = false;

  constructor(private readonly segmentsService: SegmentsService) {}

  ngOnInit(): void {
    this.selectedRecord = 0;
    this.doughnutRecord = 0;
    this.reportState$ = this.segmentsService.getNewLoadedSegments().pipe(
      tap(state => {
        if (state.report.errorMessage) {
          this.hidden = true;
        }
      }),
      filter(state => !state.report.errorMessage),
      pluck('report', 'data'),
      tap(data => {
        // trigger enter animations and layout update
        this.hidden = true;
        const solidData =
          data.providers.reduce((acc: number, { percentage }) => acc + percentage, 0) <= 100.01 &&
          !data.providers.some(({ percentage }) => percentage < 0);
        Promise.resolve().then(() => {
          this.hidden = false;
          this.solidData = solidData;
        });
      })
    );
  }

  getChartValues(records: Provider[]): number[] {
    const values = records.map(record => record.percentage / 100);
    return this.doughnutRecord > 0
      ? [
          // move selected value to the beginning
          values[this.doughnutRecord],
          ...values.slice(0, this.doughnutRecord),
          ...values.slice(this.doughnutRecord + 1, values.length)
        ]
      : values;
  }

  formatPercentage(provider: Provider): string {
    return !provider.percentage && provider.value ? '~0.1' : provider.percentage.toFixed(2);
  }

  selectRecord(index: number) {
    if (index === this.selectedRecord) {
      return;
    }
    this.selectedRecord = index;
    this.doughnutDiveState = 'out';
    setTimeout(() => {
      this.doughnutDiveState = 'in';
      this.doughnutRecord = index;
    }, 400);
  }
}
